import { render, staticRenderFns } from "./ProfileMenuDesktop.vue?vue&type=template&id=2b77e04d&"
import script from "./ProfileMenuDesktop.vue?vue&type=script&lang=js&"
export * from "./ProfileMenuDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports